import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { CONFIGS } from '../../utilities/Configs';
import { ConstructFetchBody, UrlQueryParam } from '../../utilities/Helpers';
import { LocationFaucet } from '../../utilities/Types';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField } from '@material-ui/core';

type Props = {
	faucet: LocationFaucet,
	brand: any,
	onAdd: (kegId: number) => void,
	onClose: () => void
};

export const KegAdd = (props: Props) => {
	const handleSubmit = (_values, _formikBag) => {
		const post = [
			UrlQueryParam('id'),
			-1,
			(props.faucet['bid'] || -1),
			props.faucet['fid'],
			(_values.dateBorn || '0001-01-01'),
			(_values.dateExpires || '0001-01-01'),
			_values.dateTapped,
			_values.kegSize
		];
		
		fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.KEG_UPSERT, [...[UrlQueryParam('token')], ...post])).then(
			(_response) => _response.json()
		).then(
			(_response) => {
				if (_response['error'] !== undefined) {
					alert('Error: ' + _response['error']['message']);
				}
				else {
					props.onAdd(_response.result);
					props.onClose();
				}
			}
		).catch(
			() => alert('An unexpected error has occurred. Please try again later. If problem persists, please contact support.')
		).finally(
			() => _formikBag.setSubmitting(false)
		);
	};
	
	return (
		<Formik
			initialValues={{
				kegSize: 1,
				dateTapped: (new Date()).toISOString().substr(0, 10),
				dateBorn: '',
				dateExpires: ''
			}}
			onSubmit={handleSubmit}
			validateOnBlur={false}
			validateOnChange={false}
			validationSchema={
				Yup.object().shape({
					kegSize: Yup.number(),
					dateTapped: Yup.date().required('Required'),
					dateBorn: Yup.date(),
					dateExpires: Yup.date()
				})
			}
		>
			{
				(_formik) => (
					<Dialog open maxWidth="sm" fullWidth>
						<DialogTitle>Add Keg</DialogTitle>
						<DialogContent dividers>
							<Grid container spacing={1}>
								{
									props.brand !== undefined && (
										<Grid item xs={12}>
											<p className="mute">Brands</p>
											<p className="bold">{props.brand['Value']}</p>
										</Grid>
									)
								}
								<Grid item xs={12}>
									<TextField
										name="kegSize"
										value={_formik.values.kegSize}
										label="Keg Size"
										select
										InputLabelProps={{
											shrink: true
										}}
										variant="outlined"
										margin="dense"
										fullWidth
										onChange={(_event) => _formik.setFieldValue('kegSize', _event.target.value)}
									>
										<MenuItem value={0}>None</MenuItem>
										<MenuItem value={1}>Small</MenuItem>
										<MenuItem value={2}>Large</MenuItem>
									</TextField>
								</Grid>
								<Grid item xs={12}>
									<TextField
										name="dateTapped"
										value={_formik.values.dateTapped}
										type="date"
										label="Installed On"
										InputLabelProps={{
											shrink: true
										}}
										variant="outlined"
										margin="dense"
										fullWidth
										onChange={(_event) => _formik.setFieldValue('dateTapped', _event.target.value)}
									/>
									{
										_formik.errors.dateTapped !== undefined && (
											<p className="error">{_formik.errors.dateTapped}</p>
										)
									}
								</Grid>
								<Grid item xs={12}>
									<TextField
										name="dateBorn"
										value={_formik.values.dateBorn}
										type="date"
										label="Born On"
										InputLabelProps={{
											shrink: true
										}}
										variant="outlined"
										margin="dense"
										fullWidth
										onChange={(_event) => _formik.setFieldValue('dateBorn', _event.target.value)}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										name="dateExpires"
										value={_formik.values.dateExpires}
										type="date"
										label="Expires On"
										InputLabelProps={{
											shrink: true
										}}
										variant="outlined"
										margin="dense"
										fullWidth
										onChange={(_event) => _formik.setFieldValue('dateExpires', _event.target.value)}
									/>
								</Grid>
							</Grid>
						</DialogContent>
						<DialogActions>
							<Button variant="contained" color="default" disabled={_formik.isSubmitting} onClick={props.onClose}>Cancel</Button>
							<Button variant="contained" color="primary" disabled={_formik.isSubmitting} onClick={() => _formik.handleSubmit()}>Save</Button>
						</DialogActions>
					</Dialog>
				)
			}
		</Formik>
	);
};